module.exports = __webpack_public_path__ + "img/Blue-Jay.f95dcb76.png";